module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_5250_Inactive@1x-9be62cdde0f7498831dc2e13346d862d.png";